import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Grid, Container, Typography } from '@mui/material';
import workshop1 from '../../../images/workshop1.jpg';
import workshop2 from '../../../images/workshop2.jpg';
import workshop3 from '../../../images/workshop3.jpg';
import workshop4 from '../../../images/workshop4.jpg';
import './Workshop.css'


const Workshop = () => {
    return (
        <Container sx={{ mb: 15 }}>
            <Typography variant="h1" className="heading" style={{ pb: 0, fontWeight: "700" }} data-aos="zoom-out-up" data-aos-duration="1000" data-aos-easing="ease-in-sine"
                gutterBottom>

                <span>C</span>
                <span>A</span>
                <span>M</span>
                <span>P</span>
                <span>U</span>
                <span>S</span>
                <span className="space">{""}</span>
                <span>W</span>
                <span>O</span>
                <span>R </span>
                <span>K</span>
                <span>S </span>
                <span>H </span>
                <span>O</span>
                <span>P</span>

            </Typography>
            <Typography sx={{ fontFamily: 'Raleway', color: "black", textAlign: "center" }} data-aos="zoom-out-up" data-aos-duration="1000" data-aos-easing="ease-in-sine"
                variant="h6" gutterBottom component="div">
                We're helping students on campus those who need to pass HSK-4
            </Typography>
            <Box sx={{ flexGrow: 1, pt: 5 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                        <div className="banner-single " data-aos="fade-right" data-aos-easing="linear"
                            data-aos-duration="1500">
                            <div className="banner-image">
                                <img className="banner-img " src={workshop1} alt="" />
                            </div>
                            <div className="banner-content">
                                {/* <span className="banner-text-tiny">HSK-3</span>
                                <h3 className="banner-text-large">Offline Class</h3>
                                <Link to="/shop" className="banner-link">Join Now</Link> */}
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <div className="banner-single " data-aos="fade-up" data-aos-easing="linear"
                            data-aos-duration="1500">
                            <div className="banner-image">
                                <img className="banner-img" src={workshop2} alt="" />
                            </div>
                            <div className="banner-content">
                                {/* <span className="banner-text-tiny">HSK-3</span>
                                <h3 className="banner-text-large">Offline Class</h3>
                                <Link to="/shop" className="banner-link">Join Now</Link> */}
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <div className="banner-single " data-aos="fade-left" data-aos-easing="linear"
                            data-aos-duration="1500">
                            <div className="banner-image">
                                <img className="banner-img" src={workshop3} alt="" />
                            </div>
                            <div className="banner-content">
                                {/* <span className="banner-text-tiny">HSK-3</span>
                                <h3 className="banner-text-large">Offline Class</h3>
                                <Link to="/shop" className="banner-link">Join Now</Link> */}
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Box>



        </Container>
    );
};

export default Workshop;